import React from "react";

/**
 * Shared dashboard card shell — equal-height layout with translated title
 * and icon. Consumed by every widget on the Dashboard so heights align.
 *
 * The former outer `<section>` wrapper introduced an extra visual frame
 * (border + shadow) on top of the widget content; the design brief calls
 * for a flatter feel, so we render a plain `<div>` here with just the
 * rounded surface + interior padding. Widget content still reads as a
 * card via the background, corners, and hover-free surface.
 */
export function CardShell({ title, icon: Icon, children, testId }) {
  return (
    <div
      className="flex h-full min-h-[220px] flex-col rounded-lg bg-surface p-5"
      data-testid={testId}
    >
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-sm font-semibold text-text-primary">{title}</h2>
        <span
          className="flex h-8 w-8 items-center justify-center rounded-full bg-offwhite"
          aria-hidden
        >
          <Icon className="h-4 w-4 text-champagne/70" />
        </span>
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
}
